import React, { useEffect, useState } from 'react'
import Button from "../../extras/Button";
import Input, { ExInput } from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { editData, objectToFormData, submitData } from "../../../util/fuction";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { DangerRight } from '../../api/toastServices';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { rescheduleBooking, getStaffCalendar } from '../../../redux/slice/bookingSlice';
import { expertAdd } from '../../../redux/slice/expertSlice';

const BookingDialogue = () => {
    const dispatch = useDispatch();
    const { dialogueData } = useSelector((state) => state.dialogue);

    const [c_fname, setCFname] = useState("");
    const [c_lname, setCLname] = useState("");
    const [c_email, setCEmail] = useState("");
    const [c_mobile, setCMobile] = useState("");

    const [s_fname, setSFname] = useState("");
    const [s_lname, setSLname] = useState("");
    const [s_email, setSEmail] = useState("");
    const [s_mobile, setSMobile] = useState("");

    const [startTime, setStartTime] = useState(null);
    const [date, setDate] = useState(null);


    const [disabledTimes, setDisabledTimes] = useState({});
    const [staffCalendar, setStaffCalendar] = useState([]);

    const generateDisabledTimes = (start, end) => {
        let disabledTimes = [];
        let current = new Date(start.getTime());

        while (current < end) {
            disabledTimes.push(new Date(current));
            current = new Date(current.getTime() + 15 * 60000);
        }

        return disabledTimes;
    };


    useEffect(() => {
        if (dialogueData) {
            // Set client info
            setCFname(dialogueData?.user?.fname);
            setCLname(dialogueData?.user?.lname);
            setCEmail(dialogueData?.user?.email);
            setCMobile(dialogueData?.user?.mobile);

            // Set staff info
            setSFname(dialogueData?.expert?.fname);
            setSLname(dialogueData?.expert?.lname);
            setSEmail(dialogueData?.expert?.email);
            setSMobile(dialogueData?.expert?.mobile);
            // setStaffCalenda
            dispatch(getStaffCalendar({ expertIds: [dialogueData?.expert_id] }))
                .then((res) => {
                    if (res.payload && res.payload.calendar) {
                        setStaffCalendar(res.payload.calendar);
                        if (dialogueData?.date) {
                            disableCertainDateTimes(dialogueData.date, res.payload.calendar);
                        }
                    }
                })
                .catch((err) => {
                    console.error("Error fetching calendar:", err);
                });


            console.log(dialogueData);
            // Set date
            if (dialogueData?.date) {
                setDate(new Date(dialogueData.date));

                disableCertainDateTimes(dialogueData.date);
            }

            // Set time
            if (dialogueData?.startTime) {
                // Parse the time string "HH:mm:ss" and create a Date object
                const timeParts = dialogueData.startTime.split(':');
                const timeDate = new Date();
                timeDate.setHours(parseInt(timeParts[0], 10));
                timeDate.setMinutes(parseInt(timeParts[1], 10));
                timeDate.setSeconds(parseInt(timeParts[2] || 0, 10));
                setStartTime(timeDate);
            }
        }
    }, [dialogueData]);

    const disableCertainDateTimes = (selectedDateStr, calendar = staffCalendar) => {
        const selectedDate = moment(selectedDateStr, "YYYY-MM-DD");

        const currentStart = moment(`${dialogueData.date}T${dialogueData.startTime}`);
        const currentEnd = moment(currentStart).add(dialogueData.duration, 'minutes');

        const allDisabledTimes = calendar
            .filter((item) => moment(item.date).isSame(selectedDate, "day"))
            .reduce((acc, item) => {
                const start = moment(`${item.date}T${item.start}`);
                const end = moment(`${item.date}T${item.end}`);
                const disabled = [];

                while (start.isBefore(end)) {
                    const isInCurrentBooking =
                        start.isSameOrAfter(currentStart) && start.isBefore(currentEnd);

                    if (!isInCurrentBooking) {
                        disabled.push(start.toDate());
                    }

                    start.add(15, 'minutes');
                }

                return [...acc, ...disabled];
            }, []);

        setDisabledTimes(allDisabledTimes);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Ensure both date and time are selected
        if (!date || !startTime) {
            DangerRight("Please select both date and time");
            return;
        }

        const formDataJson = {
            startTime: startTime ? moment(startTime).format("HH:mm:ss") : null,
            date: date ? moment(date).format("YYYY-MM-DD") : null,
            bookingId: dialogueData.id,
            _method: 'post',
        };

        try {
            dispatch(rescheduleBooking(formDataJson))
                .then((res) => {
                    console.log(res);
                    if (res.payload.status) {
                        dispatch(closeDialog());
                    } else {
                        DangerRight(res.payload.message || "Error rescheduling booking");
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                    DangerRight(err.message || "Something went wrong");
                });
        } catch (err) {
            console.log("err", err);
            DangerRight(err.message);
        }
    };

    return (
        <div className="dialog">
            <div className="w-100">
                <div className="row justify-content-center">
                    <div className="col-xl-5 col-md-8 col-11">
                        <div className="mainDiaogBox">
                            <div className="row justify-content-between align-items-center formHead">
                                <div className="col-8">
                                    <h2 className="text-theme m0">Appointment Booking</h2>
                                </div>
                                <div className="col-4">
                                    <div
                                        className="closeButton"
                                        onClick={() => {
                                            dispatch(closeDialog());
                                        }}
                                    >
                                        <i className="ri-close-line"></i>
                                    </div>
                                </div>
                            </div>
                            <div className="row align-items-start formBody">
                                <hr></hr>
                                <h4>Client Info: </h4>
                                <div className="col-12 col-md-6">
                                    <p><strong>Name:</strong> {c_fname + ' ' + c_lname}</p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p><strong>Email</strong> {c_email}</p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p><strong>Mobile</strong> {c_mobile}</p>
                                </div>
                                <hr></hr>
                                <h4>Staff Info: </h4>
                                <div className="col-12 col-md-6">
                                    <p><strong>Name:</strong> {s_fname + ' ' + s_lname}</p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p><strong>Email</strong> {s_email}</p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <p><strong>Mobile</strong> {s_mobile}</p>
                                </div>
                                <hr></hr>
                                <h4>Booking Info: </h4>
                                <div className="col-12">
                                    <p><strong>Status:</strong> {dialogueData?.status}</p>
                                </div>
                                <div className="col-12 col-md-6">
                                    <label htmlFor="date" className="mb-1">Date</label>
                                    <br></br>
                                    <DatePicker
                                        id="date"
                                        name="date"
                                        selected={date}
                                        onChange={(selectedDate) => {
                                            setDate(selectedDate);
                                            disableCertainDateTimes(moment(selectedDate).format("YYYY-MM-DD"));
                                        }}

                                        className="form-control w-full"
                                        placeholderText="Select Date"
                                        dateFormat="yyyy-MM-dd"
                                    />
                                </div>

                                <div className="col-12 col-md-6">
                                    <label className="d-block mb-2">Start Time</label>
                                    <DatePicker
                                        selected={startTime}
                                        onChange={setStartTime}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="Time"
                                        dateFormat="HH:mm"
                                        className="form-control w-full"
                                        placeholderText="Select Time"
                                        timeFormat="HH:mm"
                                        excludeTimes={Array.isArray(disabledTimes) ? disabledTimes : []}

                                    />
                                </div>
                            </div>
                            <div className="row formFooter">
                                <div className="col-12 text-end m0">
                                    <Button className={`bg-gray text-light`} text={`Cancel`} type={`button`} onClick={() => dispatch(closeDialog())} />
                                    <Button
                                        type={`submit`}
                                        className={`bg-theme text-light m10-left`}
                                        text={`Submit`}
                                        onClick={(e) => handleSubmit(e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingDialogue;